// Page Preloader Plugin
// Hides preloader when hero video readyState >= 3, or after 2 seconds — whichever comes first.

(function() {
    var preloader = document.getElementById('pagePreloader');
    if (!preloader) return;

    var percentageEl = document.getElementById('preloaderPercentage');
    var hidden = false;
    var p = 0;
    var progressInterval = null;

    function findHeroVideo() {
        var item = document.querySelector('.hero-home .carousel-item.active');
        return item ? item.querySelector('.carousel-item-video') : null;
    }

    function tryPlayVideo(video) {
        if (!video || video.readyState < 3) return;
        video.play().catch(function() {
            var once = function() {
                video.play().catch(function() {});
                document.removeEventListener('click', once);
                document.removeEventListener('touchstart', once);
            };
            document.addEventListener('click', once, { once: true });
            document.addEventListener('touchstart', once, { once: true });
        });
    }

    function hidePreloader() {
        if (hidden) return;
        hidden = true;

        if (progressInterval) clearInterval(progressInterval);
        if (percentageEl) percentageEl.textContent = '100%';

        preloader.classList.add('hidden-preloader');
        setTimeout(function() { preloader.remove(); }, 500);

        // var video = findHeroVideo();
        // tryPlayVideo(video);
    }

    window.__preloaderOn100 = hidePreloader;

    if (percentageEl) {
        progressInterval = setInterval(function() {
            p = Math.min(p + 3, 99);
            percentageEl.textContent = Math.floor(p) + '%';

            var video = findHeroVideo();

            if (video && video.readyState >= 4) {
                hidePreloader();
            } else if (p >= 99) {
                hidePreloader();
            }
        }, 100);
    }
})();



// WEBPACK FOOTER //
// ./resources/assets/js/preloader.plugin.js